import Cookies from 'js-cookie'
import _ from 'lodash'
import { logout } from './auth'

// const environment = process.env.API_ENV

const API_URLS = {
  prod: 'https://us-west1-skyhawks-peninsula-api.cloudfunctions.net/app',
  local: 'http://127.0.0.1:5001/skyhawks-peninsula-api/us-west1/app',
}

// if deployed you're using prod url
const API_URL_ROOT = process.env.NODE_ENV === 'development' ? API_URLS.local : API_URLS.prod

function buildHeaders(headerParameters) {
  const token = Cookies.get('token')
  const headers = {
    'cache-control': 'no-cache',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  }
  if (!_.isEmpty(headerParameters)) {
    _.forEach(Object.keys(headerParameters), (parameter) => {
      headers.append(parameter, headerParameters[parameter])
    })
  }

  return headers
}

export async function get(path, headers) {
  const result = await fetch(`${API_URL_ROOT}/${path}`, {
    headers: buildHeaders(headers),
  })
  if (result.status === 401) {
    await logout()
    window.location.reload()
    return
  }
  return await result.json()
}

export async function post(path, body, headers) {
  const result = await fetch(`${API_URL_ROOT}/${path}`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: buildHeaders(headers),
  })
  if (result.status === 403) {
    await logout()
    window.location.reload()
    return
  }
  return await result.json()
}

export async function put(path, body, headers) {
  const result = await fetch(`${API_URL_ROOT}/${path}`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: buildHeaders(headers),
  })
  if (result.status === 401) {
    await logout()
    window.location.reload()
    return
  }
  return await result.json()
}


export async function deleteApi(path) {
  const result = await fetch(`${API_URL_ROOT}/${path}`, {
    method: 'delete',
    headers: buildHeaders(),
  })
  if (result.status === 401) {
    await logout()
    window.location.reload()
    return
  }
  return await result.json()
}
